import { View } from '@zinc/ui';
import moment from 'moment';
import React from 'react';
import FieldDatePicker from '../../form/field/field-date-picker';
import FieldTimePicker from '../../form/field/field-time-picker';

interface FieldDateTimePickerProps {
  onChange: (value: Date | null) => any;
  value: Date | null;
  datePickerLabel?: string;
  timePickerLabel?: string;
  timePickerStyle?: any;
  datePickerFieldStyle?: any;
  timePickerTextFieldStyle?: any;
  timePickerClassName?: any;
  submitted?: boolean;
  errorText?: string;
  disabled?: boolean;
}

interface FieldDateTimePickerState {
  date: Date | null;
  time: Date | null;
}

export default class FieldDateTimePicker extends React.Component<
  FieldDateTimePickerProps,
  FieldDateTimePickerState
> {
  constructor(props: FieldDateTimePickerProps) {
    super(props);
    this.state = {
      date: props.value,
      time: props.value
    };
  }

  UNSAFE_componentWillReceiveProps(newProps: FieldDateTimePickerProps) {
    if (newProps.value === this.props.value) {
      return;
    }
    this.setState({ date: newProps.value, time: newProps.value });
  }

  getDateTime(date: Date | null, time: Date | null): Date | null {
    if (date === null || time === null) {
      return null;
    }
    const startDateString = moment(date).format('DD/MM/YYYY');
    const startDateTimeString = moment(time).format('HH:mm');

    return moment(startDateString + ' ' + startDateTimeString, 'DD/MM/YYYY HH:mm').toDate();
  }

  handleChange() {
    let newDate = this.getDateTime(this.state.date, this.state.time);
    this.props.onChange(newDate);
  }

  render() {
    let timePickerStyle = this.props.timePickerStyle;
    let timePickerTextFieldStyle = this.props.timePickerTextFieldStyle;
    let datePickerFieldStyle = this.props.datePickerFieldStyle;
    const { datePickerProps = {}, disabled } = this.props;
    if (timePickerStyle === undefined) {
      timePickerStyle = { width: 200 };
    }
    if (timePickerTextFieldStyle === undefined) {
      timePickerTextFieldStyle = { width: 200 };
    }
    if (datePickerFieldStyle === undefined) {
      datePickerFieldStyle = { display: 'inline-block', maxWidth: '200px' };
    }
    let dateError, timeError;
    if (!this.state.date) {
      dateError = 'Please select a valid date';
    }
    if (!this.state.time && this.props.submitted) {
      timeError = 'Please select a valid time';
    }
    return (
      <View align="center" direction="row">
        <View attributes={{ style: datePickerFieldStyle }}>
          <FieldDatePicker
            tabIndex="2"
            label={this.props.datePickerLabel || 'Date'}
            value={this.state.date}
            onChange={(e) => {
              this.setState({ date: e }, () => this.handleChange());
            }}
            submitted={this.props.submitted}
            errorText={dateError}
            datePickerProps={datePickerProps}
            disabled={disabled}
          />
        </View>
        <View className="p-l-10" attributes={{ style: { display: 'inline-block' } }}>
          <FieldTimePicker
            label={this.props.timePickerLabel || 'Time'}
            value={this.state.time}
            style={timePickerStyle}
            textFieldStyle={timePickerTextFieldStyle}
            onChange={(e) => {
              this.setState({ time: e }, () => this.handleChange());
            }}
            className={this.props.timePickerClassName}
            error={timeError != null}
            helperText={timeError}
            disabled={disabled}
          />
        </View>
      </View>
    );
  }
}
